var CONSTANTS = require('./deep-link-constants'),
    MODELS = require('./deep-link-models'),
    CONSTANTS3 = require('./deep-link-constants3'),
    arrayFind = require('array-find');
var oem = {
    kia: {
        link: 'http://www.kia.com/us/en/build',
        message: 'www.kia.com',
        build: buildKia
    },
    volvo: {
        link: 'http://www.volvocars.com/us/shopping-tools/build-your-volvo#/driveline/',
        message: 'www.volvocars.com',
        build: buildVolvo
    },
    cadillac: {
        link: 'http://www.cadillac.com/',
        message: 'www.cadillac.com',
        build: buildCadillac
    },
    honda: {
        link: 'http://automobiles.honda.com',
        message: 'automobiles.honda.com',
        build: buildHonda
    },
    hyundai: {
        link: 'https://www.hyundaiusa.com/build-your-hyundai/',
        message: 'www.hyundaiusa.com',
        build: buildHyundai
    },
    smart: {
        link: 'https://www.smart.com/us/us/',
        message: 'www.smart.com',
        build: buildSmart
    },
    maserati: {
        link: 'http://www.configurator.maserati.com/configurator/v2/?currentCountry=1&lang=en',
        message: 'www.maseratiusa.com',
        build: buildMaserati
    }
};

function buildKia(data) {
    var kiaLink = oem[data.niceName].link + '/' + data.model + '/' + data.year + '/colors-packages?trim=' +
        data.trim + '&model=' + data.code + '&exterior=' + data.extColor +
        '&interior=' + data.intColor + '&fabric=2';
    var trackingURL = (CONSTANTS3.TRACKING[data.niceName][data.model]) ? CONSTANTS3.TRACKING[data.niceName][data.model].link + '?' : '';
    return trackingURL + encodeURI(kiaLink);
}
function buildVolvo(data) {
    return oem[data.niceName].link + data.code + '/813-6USGCC-90-x-en-55117916-USD-' + data.code +
        '-x-' + data.id;
}
function buildCadillac(data) {
    if((data.year  == '2016') && (window.location.search.indexOf('story-id=ncas-469') == -1)) {
        return null;
    }
    var cadillacLink = getcadillacLink(data);
    var trackingURL = (CONSTANTS.TRACKING[data.niceName][data.model]) ? CONSTANTS.TRACKING[data.niceName][data.model].link + '?' : '';
    return trackingURL + encodeURI(cadillacLink);
}
function getcadillacLink(data) {
    if(data.year == '2017' && (data.model == 'ats-v' || data.model == 'cts-v') 
        && (window.location.search.indexOf('story-id=ncas-469') == -1)) {
        return null;
    }
    var submodel = data.submodel;
    var model = data.model;

    if(submodel == 'suv') {submodel = 'crossovers-' + submodel;}
    
    checkCadillacModel();
    submodel += 's';

    checkCadillacYear();

    return oem[data.niceName].link + submodel + '/' + model + '/build-your-own.html';
    
    function checkCadillacModel() {
        if(model.length == 3) {
            model = (data.crossover) ? (model + '-crossover') : (model + '-sedan');
        } else {
            if(model.indexOf('escalade') > -1) { model += '-suv'; }
            if(model.indexOf('-v') > 0) {
                model += '-' + submodel;
                submodel = 'v-serie';
            }
        }
    }
    function checkCadillacYear() {
        if(data.year  == '2016') {
            var cadillacLink = oem[data.niceName].link + 'preceding-year/' + model;
            if((model.indexOf('escalade') > -1) || (model.indexOf('ct6') > -1)) {
                return cadillacLink + '/build-your-own.html#/trim';
            } else {
                return cadillacLink + '.html';
            }
        }
    }
}
function buildHyundai(data) {
    return oem[data.niceName].link;
}
function buildHonda(data) {
    if(data.year == '2016') {
        return null;
    }
    
    var hondaLink = oem[data.niceName].link,
        trackingURL = (CONSTANTS3.TRACKING[data.niceName][data.model]) ? CONSTANTS3.TRACKING[data.niceName][data.model].link + '?' : '';
    if (data.year  == '2017') {
        hondaLink += '/' + data.model + '#build-price';
    } else {
        hondaLink += '/tools/build-price/accessories.aspx?ModelName=' + data.model.toUpperCase() + '&ModelYear=' + data.year  +
            '&ModelID=' + data.code;
        if(data.intColor) {
            hondaLink +=  '&EColor=' + data.extColor + '&IColor=' + data.intColor;
        }  else {
            hondaLink = hondaLink.replace('accessories', 'colors');
        }
    }
    return trackingURL + encodeURI(hondaLink);
}
function buildSmart(data) {
    if (data.year == '2016') {
        return null;
    }
    if(data.model == 'electric drive') {
        return oem[data.niceName].link + 'build-your-own/electric-drive-cars.html';
    }
    return oem[data.niceName].link + 'microsites/build-your-own/gas-cars.html';
}
function buildMaserati(data) {
    var idArray = MODELS.model.maserati;
    var trim;

    trim = arrayFind(idArray, function (modelId) {
        return (modelId.niceName.toLowerCase().replace(/ /g,'-') == data.model) && (modelId.trim == data.trim);
    }).id;
    trim = trim || data.code;

    return oem[data.niceName].link + '&modelName=' + trim;
}

module.exports = {
    oem2: oem,
    buildKia: buildKia,
    buildVolvo: buildVolvo,
    buildCadillac: buildCadillac,
    buildHonda: buildHonda,
    buildHyundai: buildHyundai,
    buildSmart: buildSmart,
    buildMaserati: buildMaserati
};


//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/deep-link/deep-link-data2.js
// module id = 185
// module chunks = 0 1 23